import { state, mutations } from './state';
import actions from './actions';
import getters from './getters';

export const clientsModule = {
  state,
  mutations,
  actions,
  getters,
};

export default clientsModule;
